import CryptoJS from 'crypto-js';

export interface PrivateUserInfo {
  userName: string;
  dbName: string;
}

export interface LoginValues {
  DBName: string;
  UserName: string;
  password: string;
  checked: boolean;
  submit: null;
}

export class StorageService {
  private key: string;

  constructor(key?: string) {
    this.key = key || import.meta.env.VITE_PRIVATE_INFO_KEY;
  }

  saveUserCredentials(userName: string, dbName: string, rememberMe: boolean): void {
    if (rememberMe) {
      const encryptedUserData = CryptoJS.AES.encrypt(JSON.stringify({ UserName: userName, DBName: dbName }), this.key).toString();
      localStorage.setItem('privateInfo', encryptedUserData);
    } else {
      localStorage.removeItem('privateInfo');
      sessionStorage.removeItem('privateInfo');
    }
  }

  saveUserName(userName: string): void {
    localStorage.setItem('userName', userName);
  }

  getSavedCredentials(): LoginValues {
    const encryptedUserData = localStorage.getItem('privateInfo');
    if (encryptedUserData) {
      try {
        const decryptedData = CryptoJS.AES.decrypt(encryptedUserData, this.key).toString(CryptoJS.enc.Utf8);
        const { UserName, DBName } = JSON.parse(decryptedData);

        return {
          DBName,
          UserName,
          password: '',
          checked: true,
          submit: null
        };
      } catch {
        // Silently fail - corrupted encrypted data will be ignored
      }
    }

    return {
      DBName: '',
      UserName: '',
      password: '',
      checked: false,
      submit: null
    };
  }
}
